<script setup lang="ts">
import i18n from '@/lang/i18n';
</script>

<template>
  <tr class="table-header">
    <td colspan="14">
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.totalTime') }}
    </td>
  </tr>
  <tr class="table-header">
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.restraint') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.workTime') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.mileage') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.driving') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.break') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.loading') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.unloading') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.shipping') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.wait') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.others') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.rest') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.duplication') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.overTime') }}
    </td>
    <td nowrap>
      {{ i18n.global.t('pages.monthlyReportWorkingTimesSetting.header.lateNightWorkingHours') }}
    </td>
  </tr>
</template>

<style scoped>
.summary-times-container td {
  padding: 7px;
  text-align: center;
  font-weight: bold !important;
  border: 1 !important;
  border-width: 2px !important;
}
.summary-times-container .table-header {
  background-color: silver !important;
}
.summary-times-container tr {
  line-height: 15px;
  font-size: 13px;
}
</style>
